import { constants as config } from '@config';

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  filter: function (element) {
    INKIVE.C.IS_MOBILE_APP || $('<div>').filterpicker({
      $svgImageElement: $(element)
    }).trigger('click');
  },

  setAsBackground: function (element) {
    const designFacade = require('../../design/design');
    const elementObject = designFacade.get(element.id);

    let url = element.getAttribute('xlink:href');

    if (elementObject.flipped.horizontal || elementObject.flipped.vertical) {
      url = element.getAttribute('data-original-href');
    }

    if ($(element).hasClass('layoutBox')) {
      $(element).removeClass('layoutBox');
      const clipPath = svgedit.utilities.getClipPath(element);
      if (clipPath) $(clipPath).parent()[0].removeChild(clipPath);
      var filterImage = $(element).attr('filter');
    }

    this.canvas.deleteSelectedElements();
    designFacade.set('background', {
      source: url,
      previous_image_flipped: elementObject.flipped,
      old_image_id: element.id,
      previous_image_filter: filterImage
    });
  },

  crop: function (element, params) {
    params = params || {};

    const restrictionsFacade = require('../../restrictions/restrictions');
    if (!restrictionsFacade.canChange(element, 'crop')) {
      return;
    }

    if (!$(element).hasClass('layoutBox')) {
      element = this._convertToLayoutBox(element, params);
      this.canvas.call('advice.show', 'convert-to-layout-box');

      let count = 10;
      const timerId = setInterval(function () {
        $('.selectorGrip.crop-handler').each(function () {
          $(this).attr('fill', count % 2 ? '#ffdd17' : '#ffffff');
        });
        count-- || clearInterval(timerId);
      }, 400);

      params.skip_selection || this.canvas.addToSelection([element], true);
    }

    if (!params.quiet) {
      const editorFacade = require('../editor');
      const zoom = editorFacade.handle('zoom', 'get');
      this.trigger('crop.start', { id: element.getAttribute('id') });

      _.defer(_.bind(function () {
        this._fitZoomToImageSize(editorFacade, element);
        this.canvas.runExtensions('showLayoutClipper', {
          layout: element,
          callback: _.bind(function () {
            this.trigger('crop.end', { id: element.getAttribute('id') });
            editorFacade.handle('zoom', 'set', { zoom });
          }, this)
        });
      }, this));
    }
  },

  _convertToLayoutBox: function (element, params) {
    const originalBox = this.canvas.getBBox(element);
    const clipPathBB = params.clip_path || originalBox;
    const oldId = element.getAttribute('id');
    const src = element.getAttribute('xlink:href');
    const smartAsset = element.getAttribute(config.smartAssets.attributes.definedAsset);
    const definedContentType = element.getAttribute(config.smartAssets.attributes.definedContentType);

    const layoutBox = this.canvas.addSvgElementFromJson({
      element: 'rect',
      curStyles: false,
      attr: {
        x: clipPathBB.x,
        y: clipPathBB.y,
        id: this.canvas.getNextId(),
        width: clipPathBB.width,
        height: clipPathBB.height
      }
    });

    $(element).remove();
    element = this.canvas.runExtensions('addLayoutBox', {
      elem: layoutBox,
      clipPathBB,
      'xlink:href': src,
      [config.smartAssets.attributes.definedAsset]: smartAsset,
      [config.smartAssets.attributes.definedContentType]: definedContentType
    });

    const scale = params.scale || 1.2;
    const newWidth = originalBox.width * scale;
    const newHeight = originalBox.height * scale;

    this.trigger('rename.' + oldId, { id: element.getAttribute('id') });
    element.setAttribute('width', newWidth);
    element.setAttribute('height', newHeight);
    element.setAttribute('x', originalBox.x - (newWidth - originalBox.width) / 2);
    element.setAttribute('y', originalBox.y - (newHeight - originalBox.height) / 2);

    $(element).addClass('layoutBox');

    return element;
  },

  _fitZoomToImageSize: function (editorFacade, element) {
    const currentZoom = editorFacade.handle('zoom', 'get');
    const clipBox = svgedit.utilities.getBBox(element);

    isFullImageZoom() || editorFacade.handle('zoom', 'fit', svgedit.utilities.getBBox(element));

    clipBox && editorFacade.handle('zoom', 'center', {
      x: clipBox.x + clipBox.height / 2,
      y: clipBox.y + clipBox.width / 2
    });

    if (editorFacade.handle('zoom', 'get') > currentZoom) {
      editorFacade.handle('zoom', 'set', { zoom: currentZoom });
    }

    function isFullImageZoom () {
      const imageBox = element.getBoundingClientRect();
      const canvasBox = $('#svgcanvas')[0].getBoundingClientRect();

      return imageBox.width < canvasBox.width &&
        imageBox.height < canvasBox.height;
    }
  }
}, Backbone.Events);
